'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59(evaluator$35) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$59__f_evaluator$15 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$59__f_evaluator$15 = evaluator$35;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$59() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$59 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$59 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$59.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$59__f_evaluator$15.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$59 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$59, "app.api.DrugRequestsAcceptedListItem$$anon$59", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$59: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$59 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$59 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$59.js.map
